import { render, staticRenderFns } from "./InfoItemsHome.vue?vue&type=template&id=c2c2fdd6&"
import script from "./InfoItemsHome.vue?vue&type=script&lang=js&"
export * from "./InfoItemsHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports